import { HttpHeaders,HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Observable } from "rxjs";

const httpOptions = {
  headers: new HttpHeaders({})
};
const JSON_HEADERS = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
export interface NovedadPayload {
  idComunicacion?: number;
  texto: string;
  usuarioEstado: string;
  fechaPublicacion?: string;
  fechaFinPublicacion?: string | null;
}

@Injectable({ providedIn: 'root' })

export class ComunicacionService {
    private baseUrl = AppComponent.baseUrl + "/comunicacion2";

    constructor(private http: HttpClient, private router: Router) {}

    obtenerNovedadesActivas(params: { desde: number; cuantas: number; usuarioEstado: string }): Observable<any> {
        return this.http.post<any>(
        `${this.baseUrl}/listarNovedadesEnfermerosFraccionadas`,
        params,
        JSON_HEADERS
        );
    }

    agregarNovedad(novedad: NovedadPayload): Observable<any> {
        const payload = { ...novedad, fechaFinPublicacion: novedad.fechaFinPublicacion || null };
        return this.http.post<any>(`${this.baseUrl}/agregarNovedadEnfermeria`, payload, JSON_HEADERS);
    }

    modificarNovedad(novedad: NovedadPayload & { idComunicacion: number }): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}/modificarComunicacion`, novedad, JSON_HEADERS);
    }

    cambiarEstadoNovedad(params: { idComunicacion: number; usuarioEstado: string }): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}/cambiarEstadoComunicacion`, params, JSON_HEADERS);
    }
    
}